import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { NewsCardView, NewsCardViewTextStyle } from "./NewsCardView";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { StealNewsCard } from "../../../flow/impl/news/StealNewsCard";
import { NewsResourcePackage } from "../../../resources/NewsResourcePackage";
import { Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { UserProfileResourcePackage } from "by/gamefactory/cityversetycoon/scenes/popups/userprofile/resources/UserProfileResourcePackage";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";

export class StealNewsCardView extends NewsCardView {
    private static readonly FROM_YOU_TEXT = 'FROM YOU';

    private playerModel: IPlayerModel;
    private newsCard: StealNewsCard;
    private coin: Sprite;

    public constructor(
        canvasScaler: ICanvasScaler,
        newsResourcesPackage: NewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        guestAvatar: Texture,
        newsCard: StealNewsCard,
        playerModel: IPlayerModel
    ) {
        super(
            newsResourcesPackage.assets_views_news_steal_background_png,
            userProfileResources,
            guestAvatar,
            newsCard.guest.firstName.toUpperCase(),
            `STOLE ${StringFormatExtention.formatWithComma(newsCard.stealAmountInCoins)}`,
            canvasScaler
        );
        this.playerModel = playerModel;
        this.newsCard = newsCard;
        this.guestNameText.style = new StealNewsCardTextStyle();
        this.messageText.style = new StealNewsCardTextStyle();
        this.createCoin(newsResourcesPackage);
        this.createSecondText();
    }

    private createCoin(newsResourcesPackage: NewsResourcePackage): void {
        this.coin = new Sprite(newsResourcesPackage.assets_views_news_coin_png);
        this.coin.width = this.coin.height = 36;
        this.coin.position.set(this.messageText.position.x + this.messageText.width + 5, 146);
        this.addChild(this.coin);
    }

    private createSecondText(): void {
        const fromYouText = new Text(StealNewsCardView.FROM_YOU_TEXT, new StealNewsCardTextStyle());
        fromYouText.position.set(398, 190);
        this.addChild(fromYouText);
    }

    protected layoutData(): void {
        this.avatar.avatarSize = new Point(120, 121);
        this.avatar.position.set(250, 96);
        this.guestNameText.position.set(398, 104);
        this.messageText.position.set(398, 148);
    }

    public accrueResult(waitForComplete: PromiseCompletionSource<void>): void {
        this.playerModel.subtractCoins(this.newsCard.stealAmountInCoins);
        waitForComplete.complete();
    }
}

class StealNewsCardTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowBlur: 5,
            dropShadowAngle: 0.7,
            dropShadowColor: "0D0606",
            dropShadowDistance: 3
        });
    }
}